import { createSlice } from "@reduxjs/toolkit";

export const userSlice = createSlice({
  name: "user",
  initialState: {
    userID: null,
    userRole: null,
    editJobId: null,
    forEdit: false,
    jobArray: null,
    applications: null, // Adding applications to the initial state
  },
  reducers: {
    setUserID: (state, action) => {
      state.userID = action.payload;
    },
    setUserRole: (state, action) => {
      state.userRole = action.payload;
    },
    setEditJobId: (state, action) => {
      state.editJobId = action.payload;
    },
    setJobArray: (state, action) => {
      state.jobArray = action.payload;
    },
    setForEdit: (state, action) => {
      state.forEdit = action.payload;
    },
    setApplications: (state, action) => {
      state.applications = action.payload;
    }
  },
});

// Action creators are generated for each case reducer function
export const { setUserID, setUserRole, setEditJobId, setJobArray, setForEdit, setApplications } = userSlice.actions;

export default userSlice.reducer;

//setUserID is the action here
//the exported reducer should be registered in the store file with a name(userReducer).